var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState, useContext, useRef } from 'react';
import { TextFieldCompact } from '@hn-ui/textfields';
import { BlueCheckbox } from '@hn-ui/checkboxes';
import { RadioButtonGroup, RadioButton } from '@hn-ui/radios';
import { Filters, Filter } from '@hn-ui/filters';
import { BlueIconButton } from '@hn-ui/buttons';
import { styled } from 'styled-components';
import { Modal } from '@hn-ui/modals';
import { Cancel } from '@hn-ui/icons';
import { useToggle } from '@hn-front/utils';
import pluralize from 'pluralize';
import ModalSlider from './ModalSlider';
import { usePostEvent } from '../Common/hooks/usePostEvent';
import { PrintableContext } from './PrintableContext';
import { ReportIssue } from './ReportIssue';
import { PdfButtonWithTooltip } from '../PdfButtonWithTooltip';
import { useAppGoogleAnalytics } from '../../../shared_app/hooks/useAppGoogleAnalytics';
var LANGUAGES = {
    en: 'english',
    es: 'spanish',
};
var MIN_INPUT_VALUE = 0;
var MAX_INPUT_VALUE = 75;
var ScModal = styled(Modal).withConfig({ displayName: "ScModal", componentId: "sc-uq06ua" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & > div:last-child {\n    width: 1020px;\n    padding: 0px;\n    overflow: hidden;\n    & > [data-id='content-box'] {\n      padding: 0px;\n    }\n  }\n"], ["\n  & > div:last-child {\n    width: 1020px;\n    padding: 0px;\n    overflow: hidden;\n    & > [data-id='content-box'] {\n      padding: 0px;\n    }\n  }\n"])));
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-ga1632" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var InputWrapper = styled.div.withConfig({ displayName: "InputWrapper", componentId: "sc-e4a1v1" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"])));
var InputText = styled.span.withConfig({ displayName: "InputText", componentId: "sc-ohvy89" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-transform: capitalize;\n"], ["\n  text-transform: capitalize;\n"])));
var PreviewBlock = styled.div.withConfig({ displayName: "PreviewBlock", componentId: "sc-zvohxa" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: 64px 40px 32px;\n  width: 575px;\n  height: 560px;\n  flex: 0 0 auto;\n"], ["\n  padding: 64px 40px 32px;\n  width: 575px;\n  height: 560px;\n  flex: 0 0 auto;\n"])));
var OptionBlock = styled.div.withConfig({ displayName: "OptionBlock", componentId: "sc-1g6ke93" })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  background: ", ";\n"], ["\n  width: 100%;\n  background: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black99;
});
var CloseButtonWrapper = styled.div.withConfig({ displayName: "CloseButtonWrapper", componentId: "sc-jl5766" })(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  height: 24px;\n  padding: 16px 16px 24px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  height: 24px;\n  padding: 16px 16px 24px;\n"])));
var RadioButtonWrapper = styled.div.withConfig({ displayName: "RadioButtonWrapper", componentId: "sc-1nir7xz" })(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin-bottom: 32px;\n"], ["\n  margin-bottom: 32px;\n"])));
var ScRadioButtonGroup = styled(RadioButtonGroup).withConfig({ displayName: "ScRadioButtonGroup", componentId: "sc-hj9wda" })(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  & > div {\n    gap: 0 80px;\n  }\n"], ["\n  & > div {\n    gap: 0 80px;\n  }\n"])));
var OptionWrapper = styled.div.withConfig({ displayName: "OptionWrapper", componentId: "sc-1arf9bv" })(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  padding: 0 40px;\n"], ["\n  padding: 0 40px;\n"])));
var Header = styled.h1.withConfig({ displayName: "Header", componentId: "sc-wz7oe9" })(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32px;\n  margin-bottom: 32px;\n  margin-top: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32px;\n  margin-bottom: 32px;\n  margin-top: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var Subheader = styled.h3.withConfig({ displayName: "Subheader", componentId: "sc-1yqk8io" })(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  margin-bottom: 24px;\n"], ["\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  margin-bottom: 24px;\n"])));
var CopiesCountWrapper = styled.div.withConfig({ displayName: "CopiesCountWrapper", componentId: "sc-3fnt45" })(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n"])));
var ScTextField = styled(TextFieldCompact).withConfig({ displayName: "ScTextField", componentId: "sc-1oxw61e" })(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  width: 55px;\n  margin-left: 8px;\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    appearance: none;\n    margin: 0;\n  }\n\n  input[type='number'] {\n    appearance: textfield;\n  }\n"], ["\n  width: 55px;\n  margin-left: 8px;\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    appearance: none;\n    margin: 0;\n  }\n\n  input[type='number'] {\n    appearance: textfield;\n  }\n"])));
var ScFilters = styled(Filters)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  margin-bottom: 32px;\n\n  button {\n    text-transform: capitalize;\n  }\n"], ["\n  margin-bottom: 32px;\n\n  button {\n    text-transform: capitalize;\n  }\n"])));
var CopiesCounter = function (_a) {
    var level = _a.level, index = _a.index, onCheckboxStatusChange = _a.onCheckboxStatusChange, onPageCountChange = _a.onPageCountChange, isPdfLoading = _a.isPdfLoading, data = _a.data;
    var ga4 = useAppGoogleAnalytics();
    var handleOnPageCountChange = useCallback(function (event) {
        var value = event.target.value;
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher("change_input_" + level, {
            category: 'Printables',
        });
        if (Number(event.target.value) < MIN_INPUT_VALUE)
            value = String(MIN_INPUT_VALUE);
        if (Number(event.target.value) > MAX_INPUT_VALUE)
            value = String(MAX_INPUT_VALUE);
        onPageCountChange(index, value);
    }, [ga4, index, level, onPageCountChange]);
    var handleOnCheckboxStatusChange = useCallback(function () {
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher("click_checkbox_" + level, {
            category: 'Printables',
        });
        onCheckboxStatusChange(index);
    }, [ga4, index, level, onCheckboxStatusChange]);
    var isCheckboxChecked = data[index].checked;
    var isCheckboxDisabled = data[index].pageCount === 0 || isPdfLoading;
    var isTextFieldDisabled = !isCheckboxChecked || isPdfLoading;
    var inputValue = data[index].value;
    return (_jsxs(CopiesCountWrapper, __assign({ "data-testid": 'copies-counter' }, { children: [_jsxs(InputWrapper, { children: [_jsx(BlueCheckbox, { checked: isCheckboxChecked, onChecked: handleOnCheckboxStatusChange, disabled: isCheckboxDisabled }, void 0), _jsx(InputText, { children: level }, void 0)] }, void 0), _jsxs(InputWrapper, { children: [_jsx(InputText, { children: "Copies:" }, void 0), _jsx(ScTextField, { disabled: isTextFieldDisabled, value: inputValue, onChange: handleOnPageCountChange, type: 'number' }, void 0)] }, void 0)] }), level));
};
var findCopyCount = function (array, level) {
    var _a;
    return String((_a = array.find(function (_a) {
        var curLevel = _a.level, checked = _a.checked;
        return curLevel === level && checked;
    })) === null || _a === void 0 ? void 0 : _a.value);
};
var PrintModal = function (_a) {
    var _b;
    var open = _a.open, onClose = _a.onClose, title = _a.title, contents = _a.contents, printableId = _a.printableId, grade = _a.grade, onDownloaded = _a.onDownloaded;
    var groupId = useContext(PrintableContext).groupId;
    var _c = useToggle(), isToggledIssue = _c.isToggled, toggleIssue = _c.toggle;
    var _d = useState(false), isPdfLoading = _d[0], setIsPdfLoading = _d[1];
    var _e = useState((_b = contents[0]) === null || _b === void 0 ? void 0 : _b.level), selectedLevel = _e[0], setSelectedLevel = _e[1];
    var _f = useState('en'), selectedLanguage = _f[0], setSelectedLanguage = _f[1];
    var _g = useState(contents.map(function (content) { return ({
        level: content.level,
        checked: false,
        value: '1',
        pageCount: content[selectedLanguage].length,
    }); })), copiesCountersData = _g[0], setCopiesCountersData = _g[1];
    var totalPageCount = copiesCountersData.reduce(function (prev, cur) {
        return cur.checked ? prev + Number(cur.value) * cur.pageCount : prev + 0;
    }, 0);
    var hasActiveCheckbox = copiesCountersData.some(function (_a) {
        var checked = _a.checked, value = _a.value, pageCount = _a.pageCount;
        return checked && Number(value) > 0 && pageCount > 0;
    });
    var isPdfButtonDisabled = !hasActiveCheckbox || isPdfLoading;
    var pdfButtonText = totalPageCount > 0 && hasActiveCheckbox
        ? "Create PDF: " + pluralize('page', totalPageCount, true)
        : 'Create PDF';
    var pdfButtonUrl = "/reports/printables/pdf?printableId=" + printableId + "&groupId=" + groupId + "&language=" + selectedLanguage + "&params=" + JSON.stringify(copiesCountersData);
    var modalSliderData = contents.length
        ? contents.filter(function (_a) {
            var level = _a.level;
            return level === selectedLevel;
        })[0][selectedLanguage]
        : [];
    var ga4 = useAppGoogleAnalytics();
    var postEvent = usePostEvent()[0];
    var handleOnDownloadPrintables = useCallback(function () {
        var eventContext = {
            pack_id: printableId,
            pack_name: title,
            copy_easy_level: findCopyCount(copiesCountersData, 'easy'),
            copy_medium_level: findCopyCount(copiesCountersData, 'medium'),
            copy_challenging_level: findCopyCount(copiesCountersData, 'challenging'),
            lang: selectedLanguage,
            total_pages: String(totalPageCount),
            grade: String(grade),
        };
        setIsPdfLoading(true);
        postEvent('click_button_create_pdf', eventContext);
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher('click_button_create_pdf', {
            category: 'Printables',
        });
    }, [
        copiesCountersData,
        ga4,
        grade,
        postEvent,
        printableId,
        selectedLanguage,
        title,
        totalPageCount,
    ]);
    var handleOnFinishDownloadPrintables = useCallback(function () {
        setIsPdfLoading(false);
        fetch("/api/teachers/printables/packs/" + printableId + "/review", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(function (res) { return res.json(); })
            .then(onDownloaded);
    }, []);
    var handleOnLevelChange = useCallback(function (value) {
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher("click_level_" + value, {
            category: 'Printables',
        });
        setSelectedLevel(value);
    }, [ga4]);
    var handleOnPageCountChange = useCallback(function (index, value) {
        setCopiesCountersData(function (data) {
            var newData = __spreadArray([], data, true);
            newData[index] = __assign(__assign({}, newData[index]), { value: value });
            return newData;
        });
    }, []);
    var handleOnCheckboxStatusChange = useCallback(function (index) {
        setCopiesCountersData(function (data) {
            var newData = __spreadArray([], data, true);
            newData[index] = __assign(__assign({}, newData[index]), { checked: !data[index].checked });
            return newData;
        });
    }, []);
    var handleOnLanguageChange = useCallback(function (event) {
        var value = event.currentTarget.value;
        var language = LANGUAGES[value];
        setCopiesCountersData(function (data) {
            var newData = data.map(function (el, i) {
                var pageCount = contents[i][value].length;
                return __assign(__assign({}, el), { checked: pageCount ? el.checked : false, pageCount: pageCount });
            });
            return newData;
        });
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher("click_radiobutton_" + language, {
            category: 'Printables',
        });
        setSelectedLanguage(value);
    }, [contents, ga4]);
    var pageNumber = useRef(1);
    var handleOnSubmitIssues = useCallback(function (issues) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = {
                        page: pageNumber.current,
                        difficulty_level: selectedLevel,
                        incorrect_difficulty: issues.includes('incorrect level of difficulty'),
                        incorrect_skill: issues.includes('skill is tagged incorrectly'),
                        content_error: issues.includes('error in content'),
                        no_space_for_answer: issues.includes('not enough room to write answers'),
                    };
                    return [4 /*yield*/, fetch("/api/teachers/printables/packs/" + printableId + "/issue", {
                            method: 'post',
                            body: JSON.stringify(data),
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    _a.sent();
                    toggleIssue();
                    return [2 /*return*/];
            }
        });
    }); }, [toggleIssue, selectedLevel]);
    return (_jsx(ScModal, __assign({ showOverlay: true, showCloseButton: false, onClose: onClose, open: open, "data-testid": 'modal' }, { children: _jsxs(Container, { children: [_jsxs(PreviewBlock, { children: [_jsx(Header, __assign({ title: title }, { children: title }), void 0), _jsx(ScFilters, __assign({ compact: true, onChange: handleOnLevelChange, value: selectedLevel, "data-testid": 'filters' }, { children: contents.map(function (_a) {
                                var level = _a.level;
                                return (_jsx(Filter, { label: level, value: level }, level));
                            }) }), void 0), _jsx(ModalSlider, { data: modalSliderData, onReportIssue: function (value) {
                                pageNumber.current = value;
                                toggleIssue();
                            }, showIssue: !isToggledIssue }, void 0)] }, void 0), _jsxs(OptionBlock, { children: [_jsx(CloseButtonWrapper, { children: _jsx(BlueIconButton, __assign({ onClick: onClose }, { children: _jsx(Cancel, { size: 24 }, void 0) }), void 0) }, void 0), _jsxs(OptionWrapper, { children: [!isToggledIssue && (_jsxs(_Fragment, { children: [_jsx(Header, { children: "Create PDF" }, void 0), _jsx(Subheader, { children: "Student pages" }, void 0), contents.map(function (_a, i) {
                                            var level = _a.level;
                                            return (_jsx(CopiesCounter, { level: level, index: i, isPdfLoading: isPdfLoading, onPageCountChange: handleOnPageCountChange, onCheckboxStatusChange: handleOnCheckboxStatusChange, data: copiesCountersData }, level));
                                        }), _jsx(Subheader, { children: "Language" }, void 0), _jsx(RadioButtonWrapper, { children: _jsxs(ScRadioButtonGroup, __assign({ defaultSelected: selectedLanguage, onChange: handleOnLanguageChange, row: true }, { children: [_jsx(RadioButton, { content: 'English', value: 'en', disabled: isPdfLoading }, void 0), _jsx(RadioButton, { content: 'Spanish', value: 'es', disabled: isPdfLoading }, void 0)] }), void 0) }, void 0), _jsx(PdfButtonWithTooltip, __assign({ apiUrl: pdfButtonUrl, disabled: isPdfButtonDisabled, size: 'small', fit: true, onClick: handleOnDownloadPrintables, onFinishLoad: handleOnFinishDownloadPrintables }, { children: pdfButtonText }), void 0)] }, void 0)), isToggledIssue && (_jsx(ReportIssue, { onCancel: toggleIssue, onSubmit: handleOnSubmitIssues }, void 0))] }, void 0)] }, void 0)] }, void 0) }), void 0));
};
export default PrintModal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;
